//
//
//
//

import m1EcuAttributesQuery from '~/apollo/queries/product/m1-pi-ecu-attributes'

export default {
  props: {
    productId: String
  },
  apollo: {
    m1EcuAttributes: {
      prefetch: true,
      query: m1EcuAttributesQuery,
      variables () {
        return { documentId: this.productId }
      }
    }
  }
}
